module.exports = __webpack_public_path__ + "media/images/common-nav/rv-parks/colorado-221f44b1b6385e09d8aa5e9c1b145b4e.jpg";